import Handler from "../Handler";

class TourneyInBreakHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTourneyInBreakRequest(receivedData);
  }
}
export default TourneyInBreakHandler;
